import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import { CardContent, Card, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useSetState } from "react-use";
import { sendOTP } from "../../graphql/mutations";
import { toastError, toastSuccess, ValidateEmail } from "../../shared/helpers";
import VerifyOTP from "./VerifyOTP";

const ResendOTP = ({ setOpens, title }) => {
  const client = useApolloClient();
  const [errMsg, setErrMsg] = useState(false);
  const [open, setOpen] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [values, setValues] = useSetState({
    email: null,
    full_name: null,
    phone_number: null,
  });

  const handleSubmit = async () => {
    if (!values.email || !values.full_name || !values.phone_number) {
      if (!ValidateEmail(values.email)) {
        setErrMsg("Email is not valid!");
      }
      setIsEmpty(true);
      setErrMsg("Please fill the form first!");
    } else {
      const resend = await sendOTP(client, values);
      if (resend.status !== "000") {
        toastError("Error, Try again later!");
      } else {
        toastSuccess("Success, please check your email or whatsapp!");
        setOpen(true);
      }
    }
  };

  return open ? (
    <VerifyOTP data={values} setOpen={setOpen} />
  ) : (
    <Box>
      <Card>
        <CardContent>
          <Box m={2}>
            <Typography variant="h2" component="h2" pb={2}>
              {title}
            </Typography>
            <p className=" font-size-main">Please enter your account correctly!</p>
          </Box>
          <Box sx={{ fontSize: "14px" }} m={2}>
            <FormGroup
              errorMessage={"Email cannot be null!"}
              isRequired
              isError={isEmpty && !values.email}
              showChildErrorSign
              label="Email"
              style={{ margin: "0 0 15px 0" }}>
              <Input
                id="email"
                name="email"
                type="email"
                onChange={(e) => setValues({ email: e.target.value })}
              />
            </FormGroup>
            <FormGroup
              showChildErrorSign
              errorMessage={"Full name cannot be null!"}
              isRequired
              isError={isEmpty && !values.nama}
              label="Full Name"
              style={{ margin: "0 0 15px 0" }}>
              <Input
                id="full_name"
                name="full_name"
                type="text"
                onChange={(e) => setValues({ full_name: e.target.value })}
              />
            </FormGroup>
            <FormGroup
              showChildErrorSign
              errorMessage={"Phone number cannot be null!"}
              isRequired
              isError={isEmpty && !values.phone_number}
              label="Phone Number"
              style={{ margin: "0 0 15px 0" }}>
              <Input
                id="phone_number"
                name="phone_number"
                type="number"
                onChange={(e) => setValues({ phone_number: e.target.value })}
              />
            </FormGroup>
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Button
              onClick={() => setOpens(false)}
              type="submit"
              variant="outlined"
              color="danger"
              style={{ marginRight: "20px" }}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResendOTP;
